export default __webpack_public_path__ + "static/media/image-home-dxp.9e7ac9e4.png";